import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { BrowserRouter as Router } from "react-router-dom"

import "bootstrap/dist/css/bootstrap.min.css"
import "react-picky/dist/picky.css"
import "./styles/main.scss"
import "es6-object-assign/dist/object-assign-auto"

import App from "./components/App"

import store from "./store"

ReactDOM.render(
  <Router basename={'/'}>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById("root"),
)
